import { gql } from 'graphql-tag'
import {
  fragmentBlockCampaignsCards,
  fragmentBlockCampaignsMedia,
  fragmentBlockContentCenteredTextOnly,
  fragmentBlockLandingLogoBar,
  fragmentBlockLogoBar,
  fragmentBlockQuoteGroup,
  fragmentBlockSimpleQuote
} from '../../../core/data-layer/blocks/fragments'
import {
  fragmentBlockLandingUspList,
} from '../fragments'
import fragmentBlockCampaignsCallOut from '../blocks/block-campaigns-call-out/fragment-block-campaigns-call-out'
import fragmentBlockLandingMediaAndText from '../blocks/block-landing-media-and-text/fragment-block-landing-media-and-text'
import fragmentBlockCampaignsMetrics from '#layers/core/data-layer/blocks/block-campaigns-metrics/fragment-block-campaigns-metrics'
import fragmentBlockLandscapeMediaThenContent from '#layers/core/data-layer/blocks/block-landscape-media-then-content/fragment-block-landscape-media-then-content'

export default gql`
  ${fragmentBlockLogoBar}
  ${fragmentBlockLandingUspList}
  ${fragmentBlockCampaignsMedia}
  ${fragmentBlockLandscapeMediaThenContent}
  ${fragmentBlockContentCenteredTextOnly}
  ${fragmentBlockSimpleQuote}
  ${fragmentBlockQuoteGroup}
  ${fragmentBlockLandingMediaAndText}
  ${fragmentBlockLandingLogoBar}
  ${fragmentBlockCampaignsCards}
  ${fragmentBlockCampaignsCallOut}
  ${fragmentBlockCampaignsMetrics}
  query ($locale: String!, $preview: Boolean!, $campaignId: String!) {
    campaign: contentKnowledgeHubCampaignsGuide(id: $campaignId, locale: $locale, preview: $preview) {
      contentBlocks: contentBlocksCollection {
        items {
          contentType: __typename
          ... on BlockLandingMediaAndText {
            ...BlockLandingMediaAndTextFragment
          }
          ... on BlockContentCenteredTextOnly {
            ...BlockContentCenteredTextOnlyFragment
          }
          ... on BlockLandscapeMediaThenContent {
            ...BlockLandscapeMediaThenContentFragment
          }
          ... on BlockCampaignsMetrics {
            ...BlockCampaignsMetricsFragment
          }
          ... on BlockCampaignsMedia {
            ...BlockCampaignsMediaFragment
          }
          ... on BlockLandingUspList {
            ...BlockLandingUspListFragment
          }
          ... on BlockSimpleQuote {
            ...BlockSimpleQuoteFragment
          }
          ... on BlockQuoteGroup {
            ...BlockQuoteGroupFragment
          }
          ... on BlockCampaignsCards {
            ...BlockCampaignsCardsFragment
          }
          ... on BlockCampaignsCallOut {
            ...BlockCampaignsCallOutFragment
          }
          ... on BlockLogoBar {
            ...BlockLogoBarFragment
          }
          ... on BlockLandingLogoBar {
            ...BlockLandingLogoBarFragment
          }
        }
      }
    }
  }
`
